import QAReportsList from "./QAReportsList";

export default QAReportsList;
